import type { ResourceType } from '@medplum/fhirtypes'
import {
  getSearchKey,
  normalizeQuery,
  type QueryTypes,
} from '@seen/core/search'
import { skipToken } from '@tanstack/react-query'
import { NO_QUERY } from '#src/constants/no-query.ts'
import { cacheKeys } from '#src/hooks/cacheKeys.ts'
import { useMedplum } from '#src/hooks/useMedplum.ts'
import { useQuery } from '#src/hooks/useQuery.ts'

// How many resources match, from `_summary=count`, without loading them.
// Undefined while loading, with no query, or if the server sends no total.
export function useSearchCount(
  type: ResourceType,
  query?: QueryTypes
): number | undefined {
  const medplum = useMedplum()
  const parameters = { ...normalizeQuery(query), _summary: 'count' }
  const searchKey = query ? getSearchKey(medplum, type, parameters) : NO_QUERY
  const { data } = useQuery({
    // oxlint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: cacheKeys.searchCount(type, searchKey),
    queryFn:
      searchKey === NO_QUERY
        ? skipToken
        : async () => (await medplum.search(type, parameters)).total ?? null,
  })
  return data ?? undefined
}
